import { MAX_YEAR, MIN_YEAR } from '../constants'

export const splitDisplayDate = (displayValue: string) => {
  const [day, month, year] = displayValue.split(/[ .:,\/]+/).map((el) => {
    if (el.length < 2) {
      return NaN
    }
    return parseInt(el, 10)
  })
  let isValid = [day, month, year].reduce((result, el) => result && !isNaN(el), true)
  if (year < MIN_YEAR || year > MAX_YEAR) {
    isValid = false
  }

  if (isValid) {
    return new Date(year, month - 1, day)
  }
  return null
}
